import { FormEvent, useEffect, useState } from 'react';
import { useChangeStatusMutation, useGetAuftraegeMutation, useTerminStornoMutation } from '../../api/AuftragAPI';
import { IAuftrag } from '../../types/Types';
import { formatToEuroDate } from '../../util/DateUtils';
import { LoadingModal } from '../../component/LoadingModal/LoadingModal';


/**
 * @author noone
 */
export type ThisProps = {
  liste: IAuftrag[];
  statusChanged: () => void;
}
export default function AuftragAnzeigeTerminiert(props: ThisProps) {

  const [terminStornoAPI] = useTerminStornoMutation();
  const [getAuftraegAPI] = useGetAuftraegeMutation();
  const [changeStatusAPI] = useChangeStatusMutation();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sortList, setSortList] = useState(new Map<number, number>());
  const [auftragsliste, setAuftragsliste] = useState<IAuftrag[]>([]);

  const statusChanged = () => {
    props.statusChanged();
  }

  const handleNextStatus = (uid: string, nextstatus: string) => {
    changeStatusAPI({ uid: uid, neuerStatus: nextstatus }).then(() => statusChanged());
  }

  const getIconBySort = (column: number) => {
    if (sortList.get(column) === -1) {
      return "bi bi-arrow-down";
    } else if (sortList.get(column) === 1) {
      return "bi bi-arrow-up";
    } else {
      return "bi bi-arrow-down-up";
    }
  }

  const sort = (number: number) => {
    console.log("s  " + number);
    sortList.forEach((value, key) => {
      if (key !== number) {
        sortList.set(key, 0);
      } else {
        if (value === 0) {
          sortList.set(key, 1);
        } else if (value === 1) {
          sortList.set(key, -1);
        } else {
          sortList.set(key, 0);
        }
      }
    });
    sortListeByColumn(number);
  }

  const sortListeByColumn = (column: number) => {
    auftragsliste.sort((a, b) => {
      if (column === 1) {
        if (sortList.get(column) === 1) {
          return a.art > b.art ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.art > b.art ? -1 : 1;
        } else return 0;
      } else if (column === 2) {
        if (sortList.get(column) === 1) {
          return a.name_endkunde > b.name_endkunde ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.name_endkunde > b.name_endkunde ? -1 : 1;
        } else return 0;
      } else if (column === 3) {
        if (sortList.get(column) === 1) {
          return a.strasse_lieferadresse > b.strasse_lieferadresse ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.strasse_lieferadresse > b.strasse_lieferadresse ? -1 : 1;
        } else return 0;
      } else if (column === 4) {
        if (sortList.get(column) === 1) {
          return a.stadt_lieferadresse > b.stadt_lieferadresse ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.stadt_lieferadresse > b.stadt_lieferadresse ? -1 : 1;
        } else return 0;
      } else if (column === 5) {
        const dateA = a.wiedervorlage ? new Date(a.wiedervorlage).getTime() : 0;
        const dateB = b.wiedervorlage ? new Date(b.wiedervorlage).getTime() : 0;
        if (sortList.get(column) === 1) {
          return dateA - dateB;
        } else if (sortList.get(column) === -1) {
          return dateB - dateA;
        } else return 0;
      } else return 0;
    });

    setAuftragsliste([...auftragsliste]);
  }

  const stornoTermin = (uid: string) => {
    terminStornoAPI(uid).then(() => statusChanged());
  }

  useEffect(() => {
    sortList.forEach((value, key) => {
      if (value !== 0) {
        console.log("Sorting by column:", key, "with value:", value);
        sortListeByColumn(key);
      }
    });

  }, [sortList]);

  useEffect(() => {
    setAuftragsliste(props.liste);

    setSortList(new Map([
      [1, 0], // Art
      [2, 0], // Name
      [3, 0], // Strasse
      [4, 0], // Lieferort
      [5, 0], // Termin
    ]));
  }, [props]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (

    <div>

      <LoadingModal show={isLoading} />

      {auftragsliste?.length === 0 && <div>Keine Aufträge vorhanden</div>}

      <table className="table" style={{ width: "100%", marginTop: "20px" }}>
        <thead>
          <tr>
            <th scope="col" onClick={() => { sort(1) }}>Art <i style={{ marginLeft: "10px" }} className={getIconBySort(1)} /></th>
            <th scope="col" onClick={() => { sort(2) }}>Name <i style={{ marginLeft: "10px" }} className={getIconBySort(2)} /></th>
            <th scope="col" onClick={() => { sort(3) }}>Strasse <i style={{ marginLeft: "10px" }} className={getIconBySort(3)} /></th>
            <th scope="col" onClick={() => { sort(4) }}>Ort <i style={{ marginLeft: "10px" }} className={getIconBySort(4)} /></th>
            <th scope="col" onClick={() => { sort(5) }}>Termin <i style={{ marginLeft: "10px" }} className={getIconBySort(5)} /></th>
            <th scope="col">Option</th>
          </tr>
        </thead>
        <tbody>

          {auftragsliste?.map((auftrag, index) => (
            <tr key={index}>
              <td>{auftrag.art}</td>
              <td>{auftrag.name_endkunde}</td>
              <td>{auftrag.strasse_lieferadresse}</td>
              <td>{auftrag.stadt_lieferadresse}</td>
              <td>{formatToEuroDate(auftrag.wiedervorlage)}</td>
              <td>
                <button
                  className="btn btn-primary"
                  onClick={(event: FormEvent) => {
                    event.stopPropagation();
                    window.open(
                      "./.auftragdetails?uid=" + auftrag?.uid + "&backbuttonClose=true",
                      "_blank"
                    );
                    /*navigate({
                      pathname: "./.auftragdetails",
                      search: "?uid=" + auftrag?.uid // + "&backbuttonClose=true",
                    });*/
                  }} ><i className='bi bi-pencil-fill'></i></button>
                <button title='Storno' className="btn btn-danger" onClick={() => stornoTermin(auftrag.uid)}><i className="bi bi-trash"></i> Termin stornieren</button>
                <button className='btn btn-primary' onClick={() => handleNextStatus(auftrag.uid, "FERTIG")} >FERTIG <i className='bi bi-arrow-right'></i> </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

}
